export enum TradeType {
    FUTURE = "FUT",
    OPTION = "OPTION",
    BROUGHT_FORWARD = "BROUGHT_FORWARD",
}

export interface Note {
    type: TradeType;
    orderId?: string | null;
    enteredAt: number; // price at entry
    closingPrice?: number | null; // for futures, required to compute P&L
    quantity: number;
    brokerage: number;
    symbol: string;
    taxes: number;
}

export interface ContractNote {
    clientId: string;
    broughtForward: Note[];
    optionTrades: Note[];
    futureTrades: Note[];
    exchangeTrades: Note[];
    date: string; // ISO/local date string from server
}


